module.exports = __webpack_public_path__ + "img/flowWisdomBlack.5992736e.png";